import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class Image2Base64ConverterService {
  constructor() {}

  convert(url) {
    return new Promise((resolve, reject) => {
      try {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          var reader = new FileReader();
          reader.onloadend = function () {
            resolve(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
      } catch (error) {
        reject('Error converting image')
      }
    });
  }
}
